import { useContext, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useIsMobile } from '~/context/common/DeviceContext';
import GlobalContext from '~/context/vdp/GlobalContext';
import { useClientSide } from '~/hooks/common';
import { getIsPartnerVehicle } from '~/selectors';
import { calculateSpinnerHeight } from '../utilities';

export default function useSpinnerSize() {
  const { headerHeight } = useContext(GlobalContext);
  const isPartnerVehicle = useSelector(getIsPartnerVehicle);
  const isClientSide = useClientSide();
  const isMobile = useIsMobile();

  return useMemo(() => {
    if (isPartnerVehicle || !isClientSide) return { focus: 0, height: 0 };

    const height = calculateSpinnerHeight(headerHeight);
    const focus = height * (isMobile ? -0.6667 : -0.1);

    return { focus, height };
  }, [headerHeight, isClientSide, isMobile, isPartnerVehicle]);
}
